import React, { useContext, useEffect } from 'react'
import { useLazyQuery, gql, NetworkStatus } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'
import ChartColumn from '../../../../components/charts/ChartColumn'
import ChartColumnSkeleton from '../../../../components/skeletons/ChartColumnSkeleton'
import { ChartColumnThemes } from '../../../../components/charts/types/ChartColumn'
import { DailyMonitoringFiltersContext } from '../../../../context/DailyMonitoringFiltersContext'
import { FilterDailyMonitoring } from '../../../../types/FilterDailyMonitoring'
import { formatDateCard, formatNumber } from '../../../../utils/Helpers'
import { STATUS_CANCELLED } from '../../../../types/Order'
import { defaultDateRange, defaultFormatTimeZone } from '../../../../utils/consts'

const GET_DATA = gql`
  query CancelationReason($filters: JSON) {
    ordersAggs(
      filters: $filters,
      size: 0,
      query: {
        bool: {
          must: [
            {
              match: {
                status_translate_keyword: "${STATUS_CANCELLED}"
              }
            }
          ]
        }
      },
      aggs: {
        reasons: {
          terms: {
            field: "cancellation_reason_translate.keyword",
            size: 2000,
            missing: "Outro"
          }
        }
      }
    ) {
      aggregations
    }
  }
`

interface Bucket {
  key: string
  doc_count: number,
  total: {
    value: number
  }
}
const CancelationReason = (): JSX.Element => {
  const { filters } = useContext(DailyMonitoringFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_DATA, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    let createdAt: FilterDailyMonitoring['dateRange'] = { ...defaultDateRange }

    if (filters.dateRange) {
      createdAt = {
        ...filters.dateRange,
        ...defaultFormatTimeZone
      }
    }
    getData({
      variables: { filters: { ...filters, createdAt } }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <ChartColumnSkeleton />
  if (loading || !data) return <ChartColumnSkeleton />
  if (error) return <p>Error :(</p>
  if (!data.ordersAggs.aggregations) return <p>No data found</p>

  const { buckets } = data.ordersAggs.aggregations.reasons
  const categories: Array<string> = []
  const seriesData: Array<number> = []
  buckets.map((bucket: Bucket) => {
    categories.push(bucket.key)
    return seriesData.push(bucket.doc_count)
  })

  const options = {
    chart: {
      id: 'cancellation-reasons'
    },
    xaxis: {
      categories
    },
    grid: {
      show: false
    },
    plotOptions: {
      bar: {
        dataLabels: {
          position: 'top'
        }
      }
    },
    dataLabels: {
      formatter: (val: number) => {
        return formatNumber(val, 0)
      },
      style: {
        colors: ['#304758']
      }
    }
  }
  const series = [{
    name: 'Qtd. Pedidos',
    data: seriesData
  }]

  if (!data) return <></>

  return <Paper elevation={2}>
    <Typography paragraph style={{ paddingLeft: '20px', paddingTop: '20px' }}>Motivos de cancelamento ({formatDateCard(filters.dateRange?.initialDate, filters.dateRange?.finalDate)})</Typography>
    <ChartColumn options={options} series={series} theme={ChartColumnThemes.red} height={320} />
  </Paper>
}

export default CancelationReason
